var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKarteHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 39.752,
    fill: "#039"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H60a0,0,0,0,1,0,0V48a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z",
    fill: "#FFCC00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 8.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.623,21.115a5.84,5.84,0,0,0,4.367-1.845,6.3,6.3,0,0,0,1.784-4.552,5.94,5.94,0,0,0-1.784-4.367A6.09,6.09,0,0,0,15.5,8.566a6.144,6.144,0,0,0-4.429,1.784,5.982,5.982,0,0,0-1.845,4.491,6.04,6.04,0,0,0,1.845,4.429,6.181,6.181,0,0,0,4.552,1.845M15.5,39.752a65.847,65.847,0,0,1-11.678-13.1Q0,20.613,0,15.922q0-7.276,4.692-11.6a15.671,15.671,0,0,1,21.616,0Q31,8.646,31,15.922q0,4.693-3.822,10.729A65.847,65.847,0,0,1,15.5,39.752",
    transform: "translate(0 0)",
    fill: "#039"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKarteHover);
export default __webpack_public_path__ + "static/media/icon-karte-hover.9ed87f9a576d1a92a2493b3357aa6c7b.svg";
export { ForwardRef as ReactComponent };